import { render, staticRenderFns } from "./PeviewPDFSingha.vue?vue&type=template&id=e0c413ac&scoped=true&"
import script from "./PeviewPDFSingha.vue?vue&type=script&lang=js&"
export * from "./PeviewPDFSingha.vue?vue&type=script&lang=js&"
import style0 from "./PeviewPDFSingha.vue?vue&type=style&index=0&id=e0c413ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c413ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
